module.exports = __webpack_public_path__ + "media/country_flags/mp-a797974c.png";